export const RemoveLessonFileMutation = `
mutation RemoveFileFromLesson($mediaitemids:[Int]!,$postpartid:Int!){
  RemoveVideoFile(mediaitemids:$mediaitemids,postpartid:$postpartid){
    success
  }
}`;
